import { Drum, Mic2, Repeat, Sparkles } from "lucide-react";
import SourceAudioUpload from "@/components/creator/music/SourceAudioUpload";

export const START_MODES = [
  { key: "scratch", label: "Start from scratch", hint: "ELPM writes the music and sings your words", Icon: Sparkles },
  { key: "add_band", label: "Add a full band under my singing", hint: "Upload your singing — ELPM plays the band", Icon: Drum },
  { key: "add_singing", label: "Add singing over my music", hint: "Upload a beat or instrumental — ELPM sings on it", Icon: Mic2 },
  { key: "grow_loop", label: "Grow my loop into a full song", hint: "Upload a loop — ELPM builds intro, verses, chorus and more", Icon: Repeat },
];

/** Create Music's first choice: from scratch, or build on a song you upload. */
export default function StartModePicker({ mode, onMode, projectId, ensureProject, source, onSource, maxSec }) {
  return (
    <section data-testid="start-mode-picker">
      <p className="mb-3 font-mono text-[11px] uppercase tracking-[0.16em] text-white/70">How do you want to start?</p>
      <div className="grid gap-2 sm:grid-cols-2">
        {START_MODES.map(({ key, label, hint, Icon }) => {
          const active = mode === key;
          return (
            <button key={key} type="button" data-testid={`start-mode-${key}`} aria-pressed={active} onClick={() => onMode(key)}
              className={`rounded-2xl border px-3.5 py-3 text-left transition-colors duration-200 ${active ? "border-blue-300/70 bg-blue-500/20 text-white" : "border-white/10 bg-white/[0.03] text-white/70 hover:bg-white/[0.07]"}`}>
              <Icon className="mb-1.5 h-4 w-4" />
              <p className="font-display text-[13px] font-semibold">{label}</p>
              <p className="mt-0.5 text-[11px] leading-snug text-white/50">{hint}</p>
            </button>
          );
        })}
      </div>
      {mode !== "scratch" ? (
        <SourceAudioUpload mode={mode} projectId={projectId} ensureProject={ensureProject} source={source} onSource={onSource} maxSec={maxSec} />
      ) : null}
    </section>
  );
}
